import {DocumentShareholdersComponent} from './corporate/document/shareholders/document.shareholders.component';
import {DocumentDirectorsComponent} from './corporate/document/directors/document.directors.component';
import {CorporateProfileDocumentComponent} from './corporate/document/corporate-profile.document.component';
import {CorporateProfileDocumentsComponent} from './corporate/corporate-profile.documents.component';

export const CORPORATE_PROFILE_DOCUMENTS_COMPONENTS = [
    CorporateProfileDocumentsComponent,
    CorporateProfileDocumentComponent,
    DocumentDirectorsComponent,
    DocumentShareholdersComponent
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/profile-details/documents/index.ts